<div class='settings-rack-container d-flex f-col'>
  <div class='menu-container d-flex'>

      <div class='h-100 flex-1 centerChild center-child-xy control-label'
          [ngClass]="{ 'selected' : overviewSelected }"
          (click)="selectMenuItem(0)">
          Overview
      </div>

      <div class='h-100 flex-1 centerChild center-child-xy control-label'
          [ngClass]="{ 'selected' : envelopeSelected }"
          (click)="selectMenuItem(1)">
          Amp
      </div>

      <div class='h-100 flex-1 centerChild center-child-xy control-label'
          [ngClass]="{ 'selected' : partialsSelected }"
          (click)="selectMenuItem(2)">
          Partials
      </div>

  </div>
  <div class='setting-container'>
    <ng-container *ngIf="overviewSelected"></ng-container>

    <ng-container *ngIf="envelopeSelected">
      <app-adsr-envelope></app-adsr-envelope>
    </ng-container>

    <ng-container *ngIf="partialsSelected"></ng-container>
  </div>

</div>
